<template>
  <div class="did">
    <shell>
      <div class="container m-auto">
        <div class="w-full lg:w-1/2 m-auto">
          
          <t-text lvl="1">Records To-Go</t-text>
          <t-text lvl="2" class="my-4">For complete exporting instructions see <a href="www.tatatap.com/importing-notes">the documentation.</a></t-text>
          <div class="my-6">
          <t-label class="mb-2">Type</t-label>
          <select v-model="exportType" class="bg-white p-2">
            <option value="STATIC_SITE">Static Website</option>
            <option value="JSON">Raw Data (JSON)</option>
          </select>
          </div>
          
          <p v-if="error" class="text-red-dark py-6">{{error}}</p>


          <div v-if="exportType === 'STATIC_SITE'">
            <form @submit.prevent="handleSubmit">
              <div class="my-4">
                <div class="mb-6">
                <t-label class="mb-2">Folder</t-label>
                <path-autocomplete v-model="exportFolder" class="mb-2" />
                <t-text lvl="2" class="mt-2 mb-4">Note: If no folder is specified, all records will be exported.</t-text>
                </div>

                <t-label class="mb-2">Title</t-label>
                <t-text-input v-model="title" class="mb-2" />
                <t-text lvl="2" class="mb-4 mt-2">(Optional) Adding a title to your site will create a heading at the top of every page with the title text linking to the homepage.</t-text>
                
              </div>
              <div class="flex items-center justify-end">
                <router-link to="/exports" class="no-underline text-black">Cancel</router-link>
                <t-button type="submit" class="ml-4">
                  Make Site!
                </t-button>
              </div>
            </form>
          </div>
          <div v-else>
            <form @submit.prevent="handleSubmit">
              <div class="flex items-center justify-end">
                <router-link to="/exports" class="no-underline text-black">Cancel</router-link>
                <t-button type="submit" class="ml-4">
                  Export Records!
                </t-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </shell>
  </div>
</template>
<script>
 import { mapState, mapActions } from 'vuex'
 import eventBus from '@/eventBus'
 import Shell from '@/components/Shell'
 import PathAutocomplete from '@/components/PathAutocomplete';
 import api from '@/api'

 export default {
   props: {

   },

   components: { Shell, PathAutocomplete },

   data () {
     return {
       error: '',
       disabled: false,
       exportFolder: '/',
       exportType: 'STATIC_SITE',
       title: ''
     }
   },

   methods: {

     resetForm () {

     },

     async handleSubmit () {
       this.disabled = true

       try {
         const {res, err} = await api.createExport(this.exportType, {folder: this.exportFolder, title: this.title})

         if (res && res.err) {
           this.error = res.err
         } else {
           this.$router.replace({path: '/exports/' + res.id})
         }
       } catch (err) {
         this.error = err.response.data

         return;
       } finally {
         this.disabled = false
       }

       this.resetForm()
     }
   },
 };
</script>
